import { map as Rmap } from "ramda";
import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

interface LineItemSummary {
  description: string;
  quantity: string;
}

interface LineItemSummaryState {
  lineItemSummaries: LineItemSummary[];
  labels: string[];
  data: string[];
}

const state: LineItemSummaryState = {
  lineItemSummaries: [],
  labels: [],
  data: [],
};

const itemDetails = {
  pluralName: "line_item_summaries",
  singularName: "line_item_summary",
};

const mutations = {
  LOAD_LINE_ITEM_SUMMARIES(
    state: LineItemSummaryState,
    payload: LineItemSummary[],
  ) {
    state.lineItemSummaries = payload;
  },
  LOAD_LABELS(state: LineItemSummaryState, payload: string[]) {
    state.labels = payload;
  },
  LOAD_DATA(state: LineItemSummaryState, payload: string[]) {
    state.data = payload;
  },
};

const actions = {
  needLineItemSummaries(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_LINE_ITEM_SUMMARIES", jsConn.response);
      const labels = Rmap(item => {
        return item.description;
      }, jsConn.response);

      const data = Rmap(item => {
        return item.quantity;
      }, jsConn.response);

      context.commit("LOAD_LABELS", labels);
      context.commit("LOAD_DATA", data);
      return Promise.resolve(jsConn);
    });
  },
};

const getters = {
  productivityChartLabels: (state: LineItemSummaryState) => {
    return state.labels;
  },
  productivityChartData: (state: LineItemSummaryState) => {
    return state.data;
  },
};

const lineItemSummariesModule = {
  state,
  mutations,
  actions,
  getters,
};

export default lineItemSummariesModule;
